export default __webpack_public_path__ + "media/images/arrow-r-359f29408851c685c2ba4ae734f4d272.svg";